import { ScanList } from './components/ScanList';
import './index.css';

const ScansPage = () => {
  return <ScanList />;
};

export default ScansPage;
